const HowToSchema = (name = '', step = '', image = '', description = '', stepName = '', url = '') =>
  JSON.stringify({
    '@context': 'http://schema.org/',
    '@type': 'HowTo',
    name,
    step: {
      '@type': 'HowToStep',
      text: step,
      image,
      name: stepName,
      url,
    },
    description,
  });

export default HowToSchema;
